









import Vue from "vue";
import { Component } from "vue-property-decorator";
import IChangeEmailModel from "@/interfaces/change-email-model";

@Component
export default class UserConfirmChangeEmail extends Vue {
  loading = false;
  success = false;
  failed = false;
  userId = "";
  code = "";
  newEmail = "";

  mounted() {
    if (
      this.$route.params &&
      this.$route.query.code &&
      this.$route.params.userId &&
      this.$route.query.newEmail
    ) {
      this.code = this.$route.query.code as string;
      this.newEmail = this.$route.query.newEmail as string;
      this.userId = this.$route.params.userId;
      //
      // Try to confirm the email address
      this.confirmEmail();
    } else {
      this.failed = true;
    }
  }

  confirmEmail() {
    if (this.code && this.userId) {
      this.loading = true;
      this.success = false;
      this.failed = false;

      const model: IChangeEmailModel = {
        code: this.code,
        userId: this.userId,
        newEmail: this.newEmail,
      };

      this.$store.dispatch("authentication/confirmChangeEmail", model).then(
        () => {
          this.loading = false;
          this.success = true;
          //
          this.$router.push({ name: "Email" });
        },
        () => {
          this.loading = false;
          this.failed = true;
        }
      );
    }
  }
}
